import 'slick-carousel';

const handler = ( $ ) => {
	const $contentSliders = $( '.testimonial-carousel__slider-content' );
	const $imageSliders = $( '.testimonial-carousel__slider-images' );

	if ( ! $contentSliders.length || ! $imageSliders.length ) return;

	$contentSliders.each( function ( index ) {
		const $currentContentSlider = $( this );
		const $currentImageSlider = $imageSliders.eq( index );
		const $wrapper = $currentContentSlider.closest(
			'.testimonial-carousel__wrapper'
		);
		const $prevArrow = $wrapper.find(
			'.testimonial-carousel__arrow--prev'
		);
		const $nextArrow = $wrapper.find(
			'.testimonial-carousel__arrow--next'
		);

		// Function to update arrows state
		const updateArrowsState = ( currentSlide, slideCount ) => {
			if ( currentSlide === 0 ) {
				$prevArrow.addClass( 'slick-disabled' );
				$nextArrow.removeClass( 'slick-disabled' );
			} else if ( currentSlide === slideCount - 1 ) {
				$prevArrow.removeClass( 'slick-disabled' );
				$nextArrow.addClass( 'slick-disabled' );
			} else {
				$prevArrow.removeClass( 'slick-disabled' );
				$nextArrow.removeClass( 'slick-disabled' );
			}
		};

		// Initialize content slider
		$currentContentSlider.slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			arrows: true,
			prevArrow: $prevArrow,
			nextArrow: $nextArrow,
			adaptiveHeight: true,
			asNavFor: $currentImageSlider,
			rows: 0, // Fix vor v1.8.0-1
		} );

		// Initialize image slider
		$currentImageSlider.slick( {
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			arrows: false,
			adaptiveHeight: true,
			asNavFor: $currentContentSlider,
			rows: 0, // Fix vor v1.8.0-1
		} );

		// Handle slider events
		$currentContentSlider.on(
			'afterChange',
			function ( event, slick, currentSlide ) {
				updateArrowsState( currentSlide, slick.slideCount );
			}
		);

		// Initialize arrows state on load
		$currentContentSlider.trigger( 'afterChange', [
			$currentContentSlider.slick( 'getSlick' ),
			0,
		] );
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
